/* eslint-disable camelcase */
import React, {Component} from 'react';
import {Highlight} from 'react-instantsearch-dom';
import Autosuggest from 'react-autosuggest';
import queryString from 'query-string';
import _ from 'underscore';
import getJobUri from '../../../../common/views/helpers/getJobUri';
import search from './utils/search';
import {FormInput} from '@homeaway/react-form-components';

export default class Hits extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            hits: [],
            suggestions: [],
        };

        this.debouncedLoadSuggestions = _.debounce(this.loadSuggestions, 500);
    }

    componentWillMount() {
        const currentSearch = queryString.parse(location.search);

        this.setState({
            value: currentSearch.search ? currentSearch.search : '',
        });
    }

    componentWillReceiveProps(props) {
        this.setState({
            hits: !this.state.value ? [] : props.hits,
        });
    }

    loadSuggestions = (value) => {
        this.props.refine(value);
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.debouncedLoadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({hits: []});
    };

    getSuggestionValue(hit) {
        return hit.Job_Title;
    }

    getSectionSuggestions(section) {
        return section.jobs;
    }

    onSuggestionSelected = (event, {suggestion}) => {
        event.preventDefault();

        const {Job_Requisition, Job_Title} = suggestion;
        const link = `/careers/job/${getJobUri(Job_Requisition, Job_Title)}`;

        this.props.history.push(link);
    };

    onKeyPress = (e) => {
        const {hits} = this.state;
        const firstHit = hits.length > 0 && hits[0];
        const hasMatch =
            firstHit &&
            firstHit._highlightResult.Job_Title.matchedWords.length > 0;

        if (e.keyCode === 9 && hasMatch) {
            this.props.queryValue(firstHit.Job_Title);
            this.setState({value: firstHit.Job_Title});
        }

        if (e.keyCode === 13) {
            search(this.state.value, this.props.history);
            e.preventDefault();
        }
    };

    renderSuggestion(hit) {
        return (
            <div>
                <Highlight attribute="Job_Title" hit={hit} />
            </div>
        );
    }

    renderSectionTitle(section) {
        return <strong>{section.location}</strong>;
    }

    renderInputComponent = (inputProps) => {
        return <FormInput label={inputProps.placeholder} {...inputProps} />;
    };

    render() {
        const groups = _.groupBy(this.state.hits, 'Location');
        const categorizedResults = Object.keys(groups).map((group) => {
            return Object.assign(
                {},
                {
                    location: group,
                    jobs: groups[group],
                },
            );
        });

        return (
            <Autosuggest
                multiSection
                renderInputComponent={this.renderInputComponent}
                onSuggestionSelected={this.onSuggestionSelected}
                suggestions={categorizedResults}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                renderSectionTitle={this.renderSectionTitle}
                getSectionSuggestions={this.getSectionSuggestions}
                inputProps={{
                    id: 'autosuggest-input',
                    placeholder: 'Job title, keywords, location',
                    value: this.state.value,
                    onChange: (event, {newValue}) => {
                        this.setState({
                            value: newValue,
                        });
                    },
                    onKeyDown: this.onKeyPress,
                }}
            />
        );
    }
}
